import { createAction } from '@ngrx/store';

export const connectWebSocket = createAction('[Repository] Websocket Connection');

export const connectWebSocketSuccess = createAction('[Repository] Websocket Connection Success');

export const connectWebSocketFailure = createAction('[Repository] Websocket Connection Failure');